'use strict'

RADIUS_IN_METERS = 3000

module.exports = class NearbyDeals
  rootUrl: '/merchant-page'

  templates:
    dealCard: require '../../deals/deal_card.html.mustache'

  constructor: ({ @$el, @place, @limit }) ->
    @fetchAndRender()

  fetchAndRender: (withCategories = true) ->
    data =
      lat: @place.location.lonLat.lat
      lon: @place.location.lonLat.lon
      limit: @limit
      radius: RADIUS_IN_METERS

    data.categories = @getCategories() if withCategories is true

    request = $.get "#{@rootUrl}/offers-map/places", data, (res) =>
      # Check if the drawer was closed before trying to insert new HTML in it.
      return unless @isElementInDom()

      deals = @getDeals res?.data?.places

      # If we get no deals in the response, we try again but with no categories.
      return @fetchAndRender(false) if withCategories is true and not (deals?.length > 0)

      # Completely hide the widget if there are no deals.
      return @hide() unless deals?.length > 0

      @render res.data.places

    request.fail =>
      return unless @isElementInDom()
      @hide()

  getCategories: ->
    return null unless @place.categories?.length > 0

    categories = []
    for category in @place.categories
      categories.push(category.uuid) unless category.uuid in categories
      categories.push(category.root.uuid) if category.root? and not (category.root.uuid in categories)

    categories.join ','

  isElementInDom: ->
    $.contains document, @$el[0]

  hide: ->
    @$el.hide()

  getDeals: (places) ->
    return null unless places?.length > 0

    deals = []
    for place in places
      items = place?.offers?.deal?.items
      deals.push items[0] if items?[0]?

    deals

  render: (places) ->
    deals = @getDeals places
    return @hide() unless deals?.length > 0

    dealsHtml = ''
    for deal in deals
      deal.forceMobileStyles = true
      deal.translate = deal.t = -> (str) -> I18n.t str
      dealsHtml += @templates.dealCard.render deal

    @$el.find('.deals').html dealsHtml
